// extracted by mini-css-extract-plugin
export var addressFields = "_lu-0";
export var animationContainer = "_lu-1";
export var footer = "_lu-2";
export var lineItems = "_lu-3";
export var modalContent = "_lu-4";
export var orderName = "_lu-5";
export var strong = "_lu-6";
export var warning = "_lu-7";